<template>
    <div>
        <form>
            <div class="form-group m-form__group row m--margin-top-10">
                <label for="photographer" class="col-3 col-form-label">
                    Fotograf
                </label>
                <div class="col-9">
                    <select v-model="project.photographer_user_id" class="form-control m-input" id="photographer" @change="dataChange = true">
                        <option value="0">Mitarbeiter wählen</option>
                        <option v-for="(photoprapher, key) in photographerArr" :value="key">{{ photoprapher }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group m-form__group row m--margin-top-10">
                <label for="manageruserid" class="col-3 col-form-label">
                    Projektmanager
                </label>
                <div class="col-9">
                    <select v-model="project.manager_user_id" class="form-control m-input" id="manageruserid" @change="dataChange = true">
                        <option value="0">Mitarbeiter wählen</option>
                        <option v-for="(photoprapher, key) in photographerArr" :value="key">{{ photoprapher }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group m-form__group row m--margin-top-10">
                <label for="kw" class="col-3 col-form-label">
                    Kalenderwoche Fotografie
                </label>
                <div class="col-9">
                    <select v-model="project.kw" class="form-control m-input" id="kw" @change="dataChange = true">
                        <option value="0">Kalenderwoche wählen</option>
                        <option v-for="(kw) in kwPlanning" :value="kw.date">{{ kw.title }} - {{ kw.count }} Projekte</option>
                    </select>
                </div>
            </div>
            <div class="form-group m-form__group row m--margin-top-10">
                <label for="prio" class="col-3 col-form-label">
                    Priorität
                </label>
                <div class="col-9">
                    <select v-model="project.current_priority_id" class="form-control m-input" id="prio" @change="dataChange = true">
                        <option value="0">Kalenderwoche wählen</option>
                        <option v-for="(prio, key) in prioArr" :value="key">{{ prio }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group m-form__group row m--margin-top-10">
                <label for="serviceprovider" class="col-3 col-form-label">
                    Dienstleister
                </label>
                <div class="col-9">
                    <select v-model="project.service_provider_id" class="form-control m-input" id="serviceprovider" @change="dataChange = true">
                        <option value="0">Dienstleister wählen</option>
                        <option v-for="(serviceProvider) in serviceProviders" :value="serviceProvider.id">{{ serviceProvider.name }}</option>
                    </select>
                </div>
            </div>
            <div class="text-right"><button @click="updateProject()" class="btn btn-success" type="button">speichern</button></div>
        </form>
    </div>
</template>

<script>
import ProjectAPI from "~/api/project";

export default {
    props: {
        projectData: Object,
        photographerArr: Object,
        kwPlanning: Object,
        prioArr: Object,
        serviceProviders: Array,
    },
    data() {
        return {
            project: null,
            dataChange: false
        }
    },
    created() {
        this.project = this.projectData;
    },
    methods: {
        updateProject(){
            ProjectAPI.postUpdateProject({
                project: this.project,
            }).then(function (response) {
                console.log(response.data);

                if(response.data == "update"){
                    //location.reload();
                }
            });
        },
    },
}
</script>
